var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Dependencies"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.alternativeLabel) + ": "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/alternative/dashboard/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.alternativeId}`,
                            expression:
                              "`/#/alternative/dashboard/${workspaceId}/${tchProjectId}/${alternativeId}`",
                          },
                        ],
                        attrs: { target: "_blank" },
                      },
                      [_vm._v(_vm._s(_vm.alternativeName))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Status: " + _vm._s(_vm.alternativeStatusName)),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
                    [
                      _c("li", { staticClass: "nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link",
                            class: { active: _vm.tab === "Foundations" },
                            on: {
                              click: function ($event) {
                                _vm.tab = "Foundations"
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Foundations (" +
                                _vm._s(_vm.foundations.length) +
                                ")\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link",
                            class: { active: _vm.tab === "Dependents" },
                            on: {
                              click: function ($event) {
                                _vm.tab = "Dependents"
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Dependents (" +
                                _vm._s(_vm.dependents.length) +
                                ")\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tab-content",
                      staticStyle: { height: "400px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tab-pane",
                          class: { active: _vm.tab === "Foundations" },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "\n                                This " +
                                _vm._s(_vm.alternativeLabel.toLowerCase()) +
                                " is dependent on " +
                                _vm._s(_vm.foundations.length) +
                                " other " +
                                _vm._s(_vm.alternativesLabel.toLowerCase()) +
                                "\n\n                                "
                            ),
                            _c(
                              "div",
                              { staticClass: "dropdown d-inline-block" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-primary",
                                    attrs: { "data-toggle": "dropdown" },
                                    on: { click: _vm.loadAlternatives },
                                  },
                                  [_vm._v("Add a foundation")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _c("form", { staticClass: "px-2 py-1" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.searchOtherPhrase,
                                            expression: "searchOtherPhrase",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Search...",
                                        },
                                        domProps: {
                                          value: _vm.searchOtherPhrase,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.searchOtherPhrase =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "max-height": "200px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    _vm._l(
                                      _vm.foundationsCandidatesView,
                                      function (a) {
                                        return _c(
                                          "a",
                                          {
                                            key: a.Id,
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleLinkFoundation(
                                                  a
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(a.Name) +
                                                "\n                                            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.foundations.length > 0
                            ? _c(
                                "table",
                                { staticClass: "table table-hover mt-3" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(_vm._s(_vm.alternativeLabel)),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c("th", {
                                        staticStyle: { width: "100px" },
                                      }),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.foundations, function (f) {
                                      return _c(
                                        "tr",
                                        {
                                          key: f.Id,
                                          class: {
                                            "table-warning":
                                              f.StatusId !==
                                              _vm.alternativeStatusId,
                                          },
                                        },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "sanitizedHref",
                                                      rawName:
                                                        "v-sanitizedHref",
                                                      value: `/#/alternative/dashboard/${_vm.workspaceId}/${_vm.tchProjectId}/${f.Id}`,
                                                      expression:
                                                        "`/#/alternative/dashboard/${workspaceId}/${tchProjectId}/${f.Id}`",
                                                    },
                                                  ],
                                                  attrs: { target: "_blank" },
                                                },
                                                [_vm._v(_vm._s(f.Name))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [_vm._v(_vm._s(f.StatusName))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-sm btn-outline-secondary",
                                                  attrs: {
                                                    title: "Remove dependency",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleUnlinkFoundation(
                                                        f
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-chain-broken",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tab-pane",
                          class: { active: _vm.tab === "Dependents" },
                        },
                        [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                "\n                                    This " +
                                  _vm._s(_vm.alternativeLabel.toLowerCase()) +
                                  " is a foundation for " +
                                  _vm._s(_vm.dependents.length) +
                                  " other " +
                                  _vm._s(_vm.alternativesLabel.toLowerCase()) +
                                  ".\n                                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "dropdown d-inline-block" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-primary",
                                    attrs: { "data-toggle": "dropdown" },
                                    on: { click: _vm.loadAlternatives },
                                  },
                                  [_vm._v("Add a dependent")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _c("form", { staticClass: "px-2 py-1" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.searchOtherPhrase,
                                            expression: "searchOtherPhrase",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Search...",
                                        },
                                        domProps: {
                                          value: _vm.searchOtherPhrase,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.searchOtherPhrase =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "max-height": "200px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dependentsCandidatesView,
                                      function (a) {
                                        return _c(
                                          "a",
                                          {
                                            key: a.Id,
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleLinkDependent(
                                                  a
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(a.Name) +
                                                "\n                                            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.dependents.length > 0
                            ? _c(
                                "table",
                                { staticClass: "table table-hover mt-3" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(_vm._s(_vm.alternativeLabel)),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c("th", {
                                        staticStyle: { width: "100px" },
                                      }),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.dependents, function (d) {
                                      return _c(
                                        "tr",
                                        {
                                          key: d.Id,
                                          class: {
                                            "table-warning":
                                              d.StatusId !==
                                              _vm.alternativeStatusId,
                                          },
                                        },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "sanitizedHref",
                                                      rawName:
                                                        "v-sanitizedHref",
                                                      value: `/#/alternative/dashboard/${_vm.workspaceId}/${_vm.tchProjectId}/${d.Id}`,
                                                      expression:
                                                        "`/#/alternative/dashboard/${workspaceId}/${tchProjectId}/${d.Id}`",
                                                    },
                                                  ],
                                                  attrs: { target: "_blank" },
                                                },
                                                [_vm._v(_vm._s(d.Name))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [_vm._v(_vm._s(d.StatusName))]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-secondary",
                                                attrs: {
                                                  title: "Remove dependency",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleUnlinkDependent(
                                                      d
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-chain-broken",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }